import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  FETCH_ALLOWED_MODULES_FAILURE,
  FETCH_ALLOWED_MODULES_SUCCESS,
  FETCH_ALLOWED_MODULES_REQUEST,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  allowedModules: [],
  message: "",
}

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      }
      break
    case FETCH_ALLOWED_MODULES_REQUEST:
      state = {
        ...state,
        loading: true,
      }
      break
    case FETCH_ALLOWED_MODULES_SUCCESS:
      console.log(action.payload.data.block_module_msg[0].text)
      state = {
        ...state,
        allowedModules: action.payload.data.modules,
        message: action.payload.data.block_module_msg[0].text,
        loading: false,
      }
      break
    case FETCH_ALLOWED_MODULES_FAILURE:
      state = {
        ...state,
        loading: false,
        allowedModules: [],
      }
      break

    case LOGIN_SUCCESS:
      localStorage.setItem("Token", JSON.stringify(action.payload.token))
      localStorage.setItem("authUser", JSON.stringify(action.payload.token))
      localStorage.setItem("sid", JSON.stringify(action.payload.sid))
      localStorage.setItem("user_id", JSON.stringify(action.payload.user_id))
      localStorage.setItem("group_id", JSON.stringify(action.payload.group_id))
      state = {
        ...state,
        loading: false,
        isUserLogout: false,
      }
      break
    case LOGOUT_USER:
      state = { ...state }
      break
    case LOGOUT_USER_SUCCESS:
      state = { ...state, isUserLogout: true }
      break
    case API_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
        isUserLogout: false,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default login
